module.exports = __webpack_public_path__ + "static/media/w1.13266cf1.svg";